<template>
  <b-navbar toggleable="lg" type="dark" variant="dark">
    <!-- <b-button v-b-toggle.sidebar-1>Toggle Sidebar</b-button> -->
    <b-button id="logo" @click="logo">
      <span class="logoIcon">
        <i class="fas fa-puzzle-piece"></i>
      </span>
    </b-button>
    <b-navbar-brand v-if="!phoneMode">iFBlock</b-navbar-brand>
    <b-navbar-nav v-show="!showProject">
      <b-nav-item-dropdown>
        <template #button-content>
          <span>{{ $t('Untitled') }}</span>
        </template>
        <b-dropdown-item @click="newProject" key="newProject">
          <i class="far fa-file"></i>
          <span>{{ $t('New Project') }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <b-navbar-nav v-show="showProject">
      <b-nav-item-dropdown>
        <template #button-content>
          <div v-show="isSampleProject">
            <i class="fab fa-stripe-s"></i>
            <span
              v-if="!phoneMode"
              class="projectName"
              :style="{ maxWidth: projectNameWidth }"
            >
              {{ projectName }}
            </span>
          </div>
          <div v-show="!isSampleProject">
            <i class="fab fa-product-hunt"></i>
            <span
              v-if="!phoneMode"
              class="projectName"
              :style="{ maxWidth: projectNameWidth }"
            >
              {{ projectName }}
            </span>
          </div>
        </template>
        <b-dropdown-item v-show="phoneMode" key="projectName" disabled>
          <span>{{ projectName }}</span>
        </b-dropdown-item>
        <b-dropdown-divider v-show="phoneMode"></b-dropdown-divider>
        <b-dropdown-item @click="newProject" key="newProject">
          <i class="far fa-file"></i>
          <span>{{ $t('New Project') }}</span>
        </b-dropdown-item>
        <b-dropdown-item @click="saveAs" key="openUserInfo">
          <i class="far fa-save"></i>
          <span>{{ $t('Save As') }}</span>
        </b-dropdown-item>
        <b-dropdown-item @click="rename" key="rename" :disabled="menuDisable">
          <i class="fas fa-edit"></i>
          <span>{{ $t('Rename') }}</span>
        </b-dropdown-item>
        <b-dropdown-item @click="remove" key="delete" :disabled="menuDisable">
          <i class="fas fa-trash"></i>
          <span>{{ $t('Delete') }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <b-button :disabled="!uid" @click="open">
      <i class="far fa-folder-open"></i>
      <span v-if="!phoneMode">{{ $t('Open') }}</span>
    </b-button>
    <b-button :disabled="!uid || !isModified" @click="save">
      <i class="fas fa-save"></i>
      <span v-if="!phoneMode">{{ $t('Save') }}</span>
    </b-button>
    <b-button @click="publish">
      <i class="fas fa-share-square"></i>
      <span v-if="!phoneMode">{{ $t('Publish') }}</span>
    </b-button>
    <b-button-group class="showCode">
      <b-button :disabled="!showCode" @click.prevent="changeShowCode">
        <i class="fas fa-puzzle-piece"></i>
        <span v-if="!phoneMode">{{ $t('Blocks') }}</span>
      </b-button>
      <b-button :disabled="showCode" @click.prevent="changeShowCode">
        <i class="fab fa-python"></i>
        <span v-if="!phoneMode">{{ $t('Python') }}</span>
      </b-button>
    </b-button-group>
    <b-navbar-nav class="ml-auto helpSetting">
      <b-button @click="help" v-if="showHelpButton">
        <i class="fa fa-question-circle"></i>
        <span>{{ $t('Help') }}</span>
      </b-button>
      <b-nav-item-dropdown right>
        <template #button-content>
          <i class="fas fa-cog"></i>
          <span v-if="!phoneMode">{{ $t('Setting') }}</span>
        </template>
        <template v-if="uid">
          <b-dropdown-item @click="openUserInfo" key="openUserInfo">
            <i class="fas fa-user"></i>
            <span>{{ displayName }}</span>
          </b-dropdown-item>
          <b-dropdown-item @click="setLanguage" key="language">
            <i class="fas fa-globe"></i>
            <span>{{ $t('Language') }}</span>
          </b-dropdown-item>
          <b-dropdown-item @click="logout" key="logout">
            <i class="fas fa-sign-out-alt"></i>
            <span>{{ $t('Logout') }}</span>
          </b-dropdown-item>
        </template>
        <template v-else>
          <b-dropdown-item @click="login" key="login">
            <i class="fas fa-sign-in-alt"></i>
            <span>{{ $t('Login') }}</span>
          </b-dropdown-item>
          <b-dropdown-item @click="setLanguage" key="language">
            <i class="fas fa-globe"></i>
            <span>{{ $t('Language') }}</span>
          </b-dropdown-item>
        </template>
        <b-dropdown-item @click="help" key="help" v-if="!showHelpButton">
          <i class="fa fa-question-circle"></i>
          <span>{{ $t('Help') }}</span>
        </b-dropdown-item>
        <b-dropdown-item @click="info" key="info">
          <i class="fas fa-info-circle"></i>
          <span>{{ $t('iFBlock Info') }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import { firebaseAuth } from '@/libs/firebase'
import ui from '@/libs/ui'
import crypto from '@/libs/crypto'
import storage from '@/libs/storage'
import util from '@/libs/util'
import file from '@/libs/file'
import { project as projectController } from '@/controller'

export default {
  name: 'Header',
  data() {
    return {
      isGuest: true,
      fileName: ''
    }
  },
  computed: {
    ...mapState([
      'code',
      'showSideBar',
      'showCode',
      'phoneMode',
      'displayWidth',
      'userInfo',
      'isAdmin',
      'isModified',
      'project',
      'language'
    ]),
    uid() {
      return _.get(this.userInfo, 'uid')
    },
    displayName() {
      return _.get(this.userInfo, 'displayName')
    },
    showProject() {
      return _.size(this.projectName) > 0
    },
    projectName() {
      const projectName = util.getProjectName(this.project, this.language)
      return projectName
    },
    isSampleProject() {
      return this.project.type === 'sample'
    },
    menuDisable() {
      return this.project.type === 'sample' && !this.isAdmin
    },
    showHelpButton() {
      return this.displayWidth > 920
    },
    projectNameWidth() {
      return this.displayWidth - 650 + 'px'
    }
  },
  methods: {
    ...mapMutations([
      'setShowSideBar',
      'setShowCode',
      'setLanguagePopupData',
      'setUserInfo',
      'setLoginData',
      'setUserPopupData',
      'setInfoPopupData',
      'setOpenProjectPopupData',
      'setHelpPopupData',
      'setProject',
      'setIsPublish'
    ]),
    logo() {
      this.setShowSideBar(!this.showSideBar)
    },
    login() {
      this.setLoginData({
        isShow: true
      })
    },
    logout() {
      firebaseAuth.logout(this.logoutSuccess, this.logoutFail)
      this.setProject({})
      storage.session.removeItem('device')
      storage.session.removeItem('showSideBar')
    },
    logoutSuccess() {
      this.setUserInfo({})
      storage.session.removeItem('userInfo')
      ui.makeToast(this, this.$t('Logout Success!'), 'success')
    },
    logoutFail(error) {
      log.error(error)
    },
    openUserInfo() {
      this.setUserPopupData({
        isShow: true
      })
    },
    setLanguage() {
      this.setLanguagePopupData({
        isShow: true
      })
    },
    info() {
      this.setInfoPopupData({
        isShow: true
      })
    },
    async newProject() {
      await projectController.removeCurrent(this)
    },
    async saveAs() {
      const param = {
        originProject: this.project
      }
      await projectController.saveAs(this, param)
    },
    async rename() {
      const param = {
        callback: this.renameHandler,
        originProject: this.project
      }
      await projectController.rename(this, param)
    },
    async renameHandler(project) {
      await projectController.setCurrent(this, project)
    },
    async remove() {
      const param = {
        callback: this.removeHandler,
        originProject: this.project
      }
      await projectController.remove(this, param)
    },
    async removeHandler() {
      await projectController.removeCurrent(this)
    },
    open() {
      this.setOpenProjectPopupData({
        isShow: true
      })
    },
    async save() {
      await projectController.save(this)
    },
    async publish() {
      this.isGuest = await firebaseAuth.checkLogin()
      log(this.isGuest)
      this.fileName = uuidv4()
      await file.setCode(this.fileName, this.code)
      this.writeFileFinish()
    },
    help() {
      log('help()')
      this.setHelpPopupData({
        isShow: true
      })
    },
    changeShowCode() {
      this.setShowCode(!this.showCode)
    },
    writeFileFinish() {
      if (this.isGuest) {
        firebaseAuth.logout()
      }
      const token = crypto.encrypt(
        `${this.fileName}__:__${this.userInfo.email}`
      )
      const terminalUrl = process.env.VUE_APP_TERMINAL_URL
      this.setIsPublish(true)
      window.location = `${terminalUrl}?lang=${this.language}&token=${token}`
    }
  }
}
</script>

<style>
.navbar.bg-dark {
  background-color: #334aff !important;
  padding: 0 1rem;
}

.navbar.bg-dark > * {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: transparent;
  border: none;
}

.navbar.bg-dark #logo {
  padding: 0;
  margin-right: 10px;
}

.navbar.bg-dark .logoIcon {
  font-size: 1.5em;
  color: white;
}

.navbar.bg-dark .navbar-brand {
  font-weight: 800;
}

.navbar.bg-dark svg + span {
  margin-left: 10px;
}

.navbar.bg-dark > .noTitle {
  font-size: 14px;
  color: white;
}

.navbar.bg-dark .b-nav-dropdown span.projectName {
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  display: inline-block;
}

/* button */
.navbar.bg-dark button {
  color: white;
  font-size: 14px;
}

.navbar.bg-dark button > svg {
  font-size: 16px;
}

/* publish button */
.navbar.bg-dark > button {
  padding-top: 0;
  padding-bottom: 0;
  height: 56px;
  font-size: 14px;
}

.navbar.bg-dark > button:hover {
  background-color: #337cf4;
  box-shadow: none;
}

.navbar.bg-dark > button:disabled:hover,
.navbar.bg-dark > button:not(:disabled):not(.disabled):active {
  background-color: #334aff;
  box-shadow: none;
}

.navbar.bg-dark > button:focus-visible {
  outline: none;
}

/* toggle button */
.showCode {
  margin: 0 auto;
}

.showCode button {
  background-color: #337cf4;
  border-color: #3359ba;
}

.showCode button:hover {
  background-color: #339ef5;
  border-color: #337aeb;
}

.showCode button.disabled {
  color: rgb(67, 120, 182);
  background-color: white;
  opacity: 1;
  /* border-color: gray; */
}

.showCode button:first-of-type {
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
}

.showCode button:last-of-type {
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
}

/* Help button */
.navbar.bg-dark .navbar-nav button {
  padding-top: 0;
  padding-bottom: 0;
  height: 56px;
  font-size: 14px;
  background-color: transparent;
  border: none;
}

.navbar.bg-dark .navbar-nav button:hover {
  background-color: #337cf4;
  box-shadow: none;
}

.navbar.bg-dark .navbar-nav button:disabled:hover,
.navbar.bg-dark .navbar-nav button:not(:disabled):not(.disabled):active {
  background-color: #334aff;
  box-shadow: none;
}

.navbar.bg-dark .navbar-nav button:focus-visible {
  outline: none;
}

/* dropdown */
.navbar.bg-dark .navbar-nav {
  padding: 0;
  margin-left: 0 !important;
}

.navbar.bg-dark .navbar-nav .nav-link {
  color: white;
  font-size: 14px;
  padding-top: 17px;
  padding-bottom: 18px;
}

.navbar.bg-dark .navbar-nav .nav-link:hover {
  color: white;
  background-color: #337cf4;
}

.navbar.bg-dark .navbar-nav .nav-link:focus-visible {
  outline: none;
}

.navbar.bg-dark .navbar-nav .nav-link svg {
  font-size: 16px;
}

.navbar.bg-dark .navbar-nav .nav-link > div {
  display: inline-block;
}

.navbar-expand-lg .navbar-nav .dropdown-menu {
  position: absolute;
}

/* help setting */
.navbar.bg-dark .navbar-nav.helpSetting,
.navbar.bg-dark .navbar-nav.helpSetting > * {
  display: inline-block;
}
</style>
